/*
 * Purpose: limit which tab can init video call
 *
 * */

import { getSessionStorageData, setSessionStorageData } from '@/utils/sessionStorage';

const PICK_UP_CONSULT_LIST_KEY = 'pickUpConsultList';

export const savePickUpConsult = (consultId, doctorId) => {
  try {
    const key = `${PICK_UP_CONSULT_LIST_KEY}_${doctorId}`;

    let currentList = [];
    const ssData = getSessionStorageData(key);

    // only assigned if data is JSON string and is an array after parsed
    if (ssData) {
      try {
        const parsedData = JSON.parse(ssData);
        currentList = Array.isArray(parsedData) ? parsedData : [];
      } catch (e) {
        currentList = [];
      }
    }

    const set = new Set(currentList);
    set.add(consultId);
    setSessionStorageData(key, JSON.stringify(Array.from(set)));
  } catch (e) {
    console.error(e);
  }
};

export const checkIsThisTabPickUpConsult = (consultId, doctorId) => {
  try {
    const key = `${PICK_UP_CONSULT_LIST_KEY}_${doctorId}`;
    const ssData = getSessionStorageData(key);

    if (ssData) {
      try {
        const parsedData = JSON.parse(ssData);
        return Array.isArray(parsedData) && parsedData.includes(consultId);
      } catch (e) {
        return false;
      }
    }

    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
};
